import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', meta, t, ...other }, ref) => (
  <>
    <Helmet>
      <title>
        {title === ''
          ? `${t(`shared.projectMainTitle.${process.env.REACT_APP_PROJECT_NAME}`)} - ${t(
              `shared.projectMainSubTitle.${process.env.REACT_APP_PROJECT_NAME}`
            )}`
          : title}
      </title>
      {meta}
    </Helmet>

    <Box ref={ref} {...other}>
      {children}
    </Box>
  </>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
  t: PropTypes.func
};

export default Page;
